import isPresent from '../../Utils/Present';

const CanViewExperimentId = (formData) => (
  formData && isPresent(formData.experiments &&
  formData.experiments.experimental &&
  formData.experiments.experiment_id)
);

export default CanViewExperimentId;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/CanViewExperimentId.tsx